<template>
  <div class="page-wrap">
    <!-- ========== 新增顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <!-- 移动端汉堡按钮 -->
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="header-right">
        <!-- 系统消息图标 -->
        <div class="header-icon">
          <i class="el-icon-bell"></i>
        </div>
        <!-- 账户下拉菜单 -->
        <div v-if="visible_loginMenu">
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-icon user-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info">资产</el-dropdown-item>
              <el-dropdown-item command="logout" divided style="color: #f53f3f">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <div class="header-icon user-icon" @click="login">
            <i class="el-icon-user"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端：左侧导航 外层容器包裹两个组件，不会横向铺开 -->
    <div v-if="!isMobile" class="sidebar-wrap">
      <LeftSide :in-drawer="true" @openSubMenu="openSubMenu" />
    </div>
    <TopSide @openSubMenu="openSubMenu2" />
    <!-- 移动端左侧抽屉菜单 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide @openSubMenu="handleMobileSubMenu" />
    </el-drawer>

    <!-- 主体内容区域 -->
    <div class="main-content">
      <div class="main-inner">
        <!-- 顶部标题 -->
        <div class="page-top-title">
          <h1><span class="blue-word">Mello,</span>一键生成爆款图！</h1>
        </div>

        <!-- ============【新增聊天对话区域，放到页面上方】============ -->
        <div class="chat-container" ref="chatScrollWrap">
          <!-- 空状态提示 -->
          <div v-if="chatList.length === 0" class="chat-empty-tip">下方输入提示词，开始AI图像创作</div>
          <!-- 循环渲染聊天消息 -->
          <div v-for="(msg, index) in chatList" :key="index" class="chat-item" :class="msg.role">
            <div class="chat-bubble">
              <!-- 用户消息：纯文字提示词 + 用户上传附件图片【已修复】 -->
              <div v-if="msg.role === 'user'">
                <div v-if="msg.content" class="chat-text">
                  {{ msg.content }}
                </div>
                <div v-if="msg.refImageUrl" class="chat-img-wrap">
                  <img :src="msg.refImageUrl" alt="用户上传参考图" @click="openImagePreview({ src: msg.refImageUrl, text: msg.content })" class="inputImg" />
                </div>
              </div>
              <!-- AI消息：文字 + 生成图片 -->
              <div v-if="msg.role === 'ai'">
                <div v-if="msg.content" class="chat-text">
                  {{ msg.content }}
                </div>
                <div v-if="msg.imageUrl" class="chat-img-wrap">
                  <img :src="msg.imageUrl" alt="生成图片" @click="openImagePreview({ src: msg.imageUrl, text: msg.content })" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 横向功能按钮行 -->
        <div class="func-row" v-if="false">
          <FuncBtn v-for="item in funcList" :key="item.id" :item="item" @click-func="handleFuncBtnClick(item)" />
        </div>

        <!-- 分类标签栏 -->
        <div class="tab-search-bar" v-if="false">
          <div class="tab-list">
            <span class="tab" :class="{ active: currentTab === 'all' }" @click="currentTab = 'all'">全部</span>
            <span class="tab" :class="{ active: currentTab === 'mainImage' }" @click="currentTab = 'mainImage'">主图+</span>
            <span class="tab" :class="{ active: currentTab === 'detail' }" @click="currentTab = 'detail'">详情页+</span>
            <span class="tab" :class="{ active: currentTab === 'matting' }" @click="currentTab = 'matting'">智能抠图</span>
            <span class="tab" :class="{ active: currentTab === 'retouch' }" @click="currentTab = 'retouch'">商品精修</span>
          </div>
          <el-input placeholder="新年贺岁图片" style="width: 220px"></el-input>
        </div>

        <!-- 作品瀑布流 -->
        <div class="waterfall-list" v-if="false">
          <div class="waterfall-item" v-for="(img, idx) in filterImgList" :key="idx" @click="openImagePreview(img)">
            <img :src="img.src" alt="" />
            <div class="item-info">{{ img.text }}</div>
          </div>
        </div>

        <!-- ============【底部固定输入框区域】============ -->
        <div class="input-wrap">
          <div class="input-box" ref="topInputBox">
            <!-- 比例选择 + 分辨率下拉 -->
            <div class="ratio-select-row">
              <!-- 新增平台选择下拉 -->
              <div class="platform-select-row">
                <el-select v-model="selectedPlatform" placeholder="请选择电商平台" size="small">
                  <el-option label="淘宝/天猫/1688" value="taobao"></el-option>
                  <el-option label="京东/抖音/国内平台" value="jd_douyin"></el-option>
                  <el-option label="外贸电商平台" value="foreign"></el-option>
                </el-select>
              </div>

              <div class="ratio-title">选择比例</div>
              <!-- 比例下拉组件 -->
              <div class="ratio-select-wrap">
                <!-- 下拉头部：默认显示 选择比例，选中后显示label -->
                <div class="ratio-select-trigger" @click="ratioDropdownOpen = !ratioDropdownOpen">
                  <span>{{ selectedRatio ? ratioList.find((r) => r.value === selectedRatio)?.label : '选择比例' }}</span>
                  <i class="arrow-icon" :class="{ open: ratioDropdownOpen }"></i>
                </div>

                <!-- 下拉弹窗面板 -->
                <div v-if="ratioDropdownOpen" class="ratio-dropdown-panel">
                  <div
                    v-for="item in ratioList"
                    :key="item.value"
                    class="ratio-item"
                    :class="{ active: selectedRatio === item.value }"
                    @click="
                      selectedRatio = item.value
                      ratioDropdownOpen = false
                    "
                  >
                    <div class="ratio-icon">
                      <div :class="['ratio-shape', 'shape-' + item.value]"></div>
                    </div>
                    <div class="ratio-text">{{ item.label }}</div>
                  </div>
                </div>
              </div>

              <el-select v-model="selectedResolution" placeholder="分辨率" size="small" class="resolution-select" v-if="false">
                <el-option label="1K" value="1K"></el-option>
                <el-option label="1.5K" value="1.5K"></el-option>
                <el-option label="2K" value="2K"></el-option>
              </el-select>
            </div>

            <div class="input-top-row">
              <div class="input-left-add">
                <el-upload ref="uploadRef" action="" :auto-upload="false" :limit="1" accept="image/jpeg,image/png,image/webp" :show-file-list="false" :on-change="handleRefImageChange" :on-remove="handleRefImageRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <div v-if="refImagePreviewUrl" class="ref-img-preview">
                <img :src="refImagePreviewUrl" alt="参考图" />
                <i class="el-icon-close ref-img-close" @click="clearRefImage"></i>
              </div>
              <textarea class="main-input" v-model="userPrompt0" placeholder="输入想法、剧本或上传参考，支持使用技能，@ 添加主体，和Agent一起创作" :disabled="generating"></textarea>

              <div class="input-btn-col">
                <el-button type="primary" class="ai-write-btn" @click="handleAiWrite" :disabled="generating" :loading="aiWriting">AI帮写</el-button>
                <el-button type="primary" class="generate-btn" @click="run" :loading="generating">一键生成</el-button>
              </div>
            </div>

            <!-- 输入框底部操作栏 -->
            <div class="input-bottom-bar" v-if="true">
              <div class="left-btns">
                <el-button size="mini" icon="el-icon-delete" @click="clearImgCache" :disabled="generating">清空缓存</el-button>
              </div>
              <div class="right-btns">
                <i class="el-icon-microphone"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- 悬浮AI按钮 -->
        <div class="float-ai-btn">AI</div>
      </div>
    </div>

    <!-- ========== 大图预览弹窗 ========== -->
    <div class="preview-mask" v-if="previewVisible" @click.self="closePreview">
      <div class="preview-box">
        <i class="el-icon-close preview-close" @click="closePreview"></i>
        <img class="preview-img" :src="currentPreviewImg.src" alt="" />
        <div class="preview-toolbar">
          <el-button type="primary" size="small" @click="downloadImage" v-if="isMember"> <i class="el-icon-download"></i> 下载保存 </el-button>
        </div>
      </div>
    </div>

    <!-- ========== 技能弹窗 ========== -->
    <el-dialog title="选择技能" :visible.sync="skillDialogVisible" width="520px">
      <div>技能列表占位，后续填充业务技能</div>
    </el-dialog>

    <!-- ========== 右侧抽屉：电商图子菜单 ========== -->
    <el-drawer :visible.sync="subDrawerVisible" direction="rtl" size="260px" title="电商图设计" :before-close="closeSubDrawer">
      <div class="sub-menu-list">
        <div class="sub-menu-item" v-for="subItem in subMenuList" :key="subItem.path" @click="goPage(subItem.path)">
          <i :class="subItem.icon"></i>
          <span>{{ subItem.title }}</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import TopSide from '@/components/TopSide.vue'
import LeftSide from '@/components/LeftSide.vue'
import FuncBtn from '@/components/FuncBtn.vue'
export default {
  components: { LeftSide, FuncBtn, TopSide },
  data() {
    return {
      visible_loginMenu: !!window.sessionStorage.getItem('token'),
      isMobile: false,
      mobileMenuDrawer: false,
      userPrompt0: '',
      userPrompt: '',
      isMember: parseInt(window.sessionStorage.getItem('isMember')) > 0, // 是否是会员
      generating: false,
      subDrawerVisible: false,
      aiWriting: false,

      showBottomInput: false,
      refImageFile: null,
      refImagePreviewUrl: '',
      previewVisible: false,
      currentPreviewImg: {},

      // 新增聊天对话数组
      chatList: [],

      // 新增平台下拉
      selectedPlatform: '',
      // 比例
      ratioDropdownOpen: false,
      selectedRatio: '1:1',
      ratioList: [
        { label: '智能', value: 'auto' },
        { label: '21:9', value: '21:9' },
        { label: '16:9', value: '16:9' },
        { label: '3:2', value: '3:2' },
        { label: '4:3', value: '4:3' },
        { label: '1:1', value: '1:1' },
        { label: '3:4', value: '3:4' },
        { label: '2:3', value: '2:3' },
        { label: '9:16', value: '9:16' }
      ],
      // 分辨率
      selectedResolution: '1.5K',

      // tab分类相关
      currentTab: 'all',
      currentFuncType: 'mainImage',
      agentMode: false,
      autoMode: false,
      skillDialogVisible: false,

      subMenuList: [
        { title: '商品主图', icon: 'el-icon-picture', path: '/index' },
        { title: '详情页设计', icon: 'el-icon-document', path: '/index' },
        { title: '场景效果图', icon: 'el-icon-s-platform', path: '/index' },
        { title: '批量修图', icon: 'el-icon-s-tools', path: '/index' }
      ],
      // 每个按钮增加 promptText：点击后追加的系统提示词
      funcList: [
        {
          id: 4,
          name: '主图+',
          desc: '人与AI同屏',
          color: '#222222',
          badge: 'Beta',
          icon: 'el-icon-magic-stick',
          promptText: '电商商品主图，高清商业摄影，产品突出，干净纯白背景，商业质感，8k，商品实拍图',
          btnType: 'mainImage'
        },
        {
          id: 5,
          name: '详情页+',
          desc: '自由创作',
          color: '#22b8e6',
          badge: '',
          icon: 'el-icon-picture',
          promptText: '电商详情页配图，场景氛围感，产品场景展示，高级商业光影，构图丰富，适合网页详情使用',
          btnType: 'detail'
        },
        {
          id: 6,
          name: '智能抠图',
          desc: '抠图创作',
          color: '#22b8e6',
          badge: '',
          icon: 'el-icon-video-camera',
          promptText: '主体清晰，纯色透明背景，主体边缘干净，适合抠图，无多余杂物，主体完整保留',
          btnType: 'matting'
        },
        {
          id: 7,
          name: '商品精修',
          desc: '全场景效果提升',
          color: '#22b8e6',
          badge: 'New',
          icon: 'el-icon-picture-outline',
          promptText: '商品精修，质感提升，细腻材质，高级布光，商业修图，画面干净通透，商品细节拉满',
          btnType: 'retouch'
        }
      ],
      imgList: [
        { src: 'https://picsum.photos/id/1015/400/280', text: '抖音AI创作大赛 已有7618人参与', type: 'mainImage' },
        { src: 'https://picsum.photos/id/1011/400/280', text: '绿茵狂飙 GRASS CRAZE', type: 'detail' },
        { src: 'https://picsum.photos/id/1027/400/280', text: '人像创作案例', type: 'matting' },
        { src: 'https://picsum.photos/id/1031/400/280', text: '我所向往的生活', type: 'retouch' },
        { src: 'https://picsum.photos/id/1036/400/280', text: '可爱IP短视频', type: 'mainImage' }
      ]
    }
  },
  created() {
    // ============【新增：页面加载读取聊天记录】============
    const chatStr = window.sessionStorage.getItem('ai_chat_list')
    if (chatStr) {
      try {
        const arr = JSON.parse(chatStr)
        if (Array.isArray(arr)) {
          this.chatList = arr
        }
      } catch (e) {
        console.warn('聊天记录解析失败', e)
        window.sessionStorage.removeItem('ai_chat_list')
      }
    }

    // 页面打开读取session缓存图片列表
    const cacheStr = window.sessionStorage.getItem('imgList')
    if (cacheStr) {
      try {
        const cacheArr = JSON.parse(cacheStr)
        if (Array.isArray(cacheArr)) {
          this.imgList = cacheArr
        }
      } catch (e) {
        console.warn('imgList缓存解析失败', e)
      }
    }
  },
  watch: {
    // ============【新增：监听chatList自动保存】============
    chatList: {
      handler(newVal) {
        window.sessionStorage.setItem('ai_chat_list', JSON.stringify(newVal))
      },
      deep: true
    }
  },
  computed: {
    filterImgList() {
      if (this.currentTab === 'all') return this.imgList
      return this.imgList.filter((img) => img.type === this.currentFuncType)
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
    window.addEventListener('scroll', this.debounceCheckScroll)
    this.checkScroll()
    document.addEventListener('click', this.handleClickOutside)
    // 恢复聊天后滚动到底部
    this.$nextTick(() => {
      this.scrollChatToBottom()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
    window.removeEventListener('scroll', this.debounceCheckScroll)
    document.removeEventListener('click', this.handleClickOutside)
    if (this.refImagePreviewUrl) URL.revokeObjectURL(this.refImagePreviewUrl)
  },
  methods: {
    // 聊天窗口自动滚动到底部
    scrollChatToBottom() {
      this.$nextTick(() => {
        if (this.$refs.chatScrollWrap) {
          this.$refs.chatScrollWrap.scrollTop = this.$refs.chatScrollWrap.scrollHeight
        }
      })
    },

    // ============【新增：一键清空全部聊天历史】============
    clearChatHistory() {
      this.$confirm('确定清空全部聊天对话记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.chatList = []
          window.sessionStorage.removeItem('ai_chat_list')
          this.$message.success('聊天记录已清空')
        })
        .catch(() => {})
    },

    async handleAiWrite() {
      if (this.aiWriting) return
      const guestMob = this.testUser()
      if (!guestMob.trim()) {
        return
      }
      // 当前页面单张参考图，校验refImageFile
      if (!this.refImageFile) {
        this.$message.warning('请先上传【参考爆款图】，AI基于图片生成卖点')
        return
      }
      const platformMap = {
        taobao: '生成一张用于淘宝天猫1688风格的图片',
        jd_douyin: '生成一张用于京东抖音国内电商的图片',
        foreign: '生成一张用于外贸跨境电商，要求纯英文版本的设计图'
      }
      const platformSuffix = platformMap[this.selectedPlatform] || ''

      this.aiWriting = true
      try {
        const formData = new FormData()
        formData.append('images', this.refImageFile)
        formData.append('platform', this.selectedPlatform)
        formData.append('prompt', '仔细观察这张产品实物图片，识别产品是什么，提取图片上看得见的硬件、结构、外观、工艺细节，生成5‑8条电商短卖点，每条简短有力，适合做主图标签，不要编造图片不存在的功能。输出格式：产品名称+卖点列表。')

        const res = await this.$http.post('/api/ai_image2text', formData)
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg || 'AI生成卖点失败')
          return
        }
        const aiText = res.data.data.content || ''
        if (!aiText.trim()) {
          this.$message.warning('AI未能识别图片卖点，请更换图片重试')
          return
        }
        // 回填到页面textarea输入框 userPrompt0
        this.userPrompt0 = aiText.trim() + '\n' + platformSuffix
        this.$message.success('AI已根据图片生成卖点')
      } catch (err) {
        console.error('ai帮写异常', err)
        this.$message.error('AI调用异常，请稍后重试')
      } finally {
        this.aiWriting = false
      }
    },

    handleClickOutside(e) {
      const dom = document.querySelector('.ratio-select-wrap')
      if (dom && !dom.contains(e.target)) {
        this.ratioDropdownOpen = false
      }
    },
    handleMobileSubMenu() {
      this.openSubMenu()
      this.mobileMenuDrawer = false
    },

    // 保存imgList到sessionStorage封装方法
    saveImgListCache() {
      window.sessionStorage.setItem('imgList', JSON.stringify(this.imgList))
    },
    // 新增：清除图片缓存
    clearImgCache() {
      this.$confirm('确定要清空本地图片历史缓存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          window.sessionStorage.removeItem('imgList')
          this.imgList = [
            { src: 'https://picsum.photos/id/1015/400/280', text: '抖音AI创作大赛 已有7618人参与', type: 'mainImage' },
            { src: 'https://picsum.photos/id/1011/400/280', text: '绿茵狂飙 GRASS CRAZE', type: 'detail' },
            { src: 'https://picsum.photos/id/1027/400/280', text: '人像创作案例', type: 'matting' },
            { src: 'https://picsum.photos/id/1031/400/280', text: '我所向往的生活', type: 'retouch' },
            { src: 'https://picsum.photos/id/1036/400/280', text: '可爱IP短视频', type: 'mainImage' }
          ]
          this.$message.success('本地图片缓存已清空')
        })
        .catch(() => {})
      this.clearChatHistory()
    },

    // 功能按钮点击统一分发
    handleFuncBtnClick(item) {
      switch (item.btnType) {
        case 'agent':
          this.agentMode = !this.agentMode
          item.value = this.agentMode
          this.$message.success(this.agentMode ? 'Agent模式已开启' : 'Agent模式关闭')
          break
        case 'auto':
          this.autoMode = !this.autoMode
          item.value = this.autoMode
          this.$message.success(this.autoMode ? '自动模式开启' : '自动模式关闭')
          if (this.autoMode) this.runGenerate()
          break
        case 'skill':
          this.skillDialogVisible = true
          break
        case 'mainImage':
          this.currentFuncType = 'mainImage'
          this.currentTab = 'mainImage'
          if (item.promptText) {
            if (this.userPrompt.trim()) {
              this.userPrompt = this.userPrompt.trim() + '，' + item.promptText
            } else {
              this.userPrompt = item.promptText
            }
          }
          this.$message.info('已切换到【主图+】模式')
          break
        case 'detail':
          this.currentFuncType = 'detail'
          this.currentTab = 'detail'
          if (item.promptText) {
            if (this.userPrompt.trim()) {
              this.userPrompt = this.userPrompt.trim() + '，' + item.promptText
            } else {
              this.userPrompt = item.promptText
            }
          }
          this.$message.info('已切换到【详情页+】模式')
          break
        case 'matting':
          this.currentFuncType = 'matting'
          this.currentTab = 'matting'
          if (item.promptText) {
            if (this.userPrompt.trim()) {
              this.userPrompt = this.userPrompt.trim() + '，' + item.promptText
            } else {
              this.userPrompt = item.promptText
            }
          }
          this.$message.info('已切换到【智能抠图】模式')
          break
        case 'retouch':
          this.currentFuncType = 'retouch'
          this.currentTab = 'retouch'
          if (item.promptText) {
            if (this.userPrompt.trim()) {
              this.userPrompt = this.userPrompt.trim() + '，' + item.promptText
            } else {
              this.userPrompt = item.promptText
            }
          }
          this.$message.info('已切换到【商品精修】模式')
          break
      }
    },

    checkDevice() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) {
        this.mobileMenuDrawer = false
      }
    },

    handleRefImageChange(file) {
      if (!file.raw) return
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.warning('参考图片不能大于5MB')
        if (this.$refs.uploadRef) this.$refs.uploadRef.clearFiles()
        return
      }
      this.refImageFile = file.raw
      this.refImagePreviewUrl = URL.createObjectURL(file.raw)
    },
    handleRefImageRemove() {
      this.clearRefImage()
    },
    clearRefImage() {
      if (this.refImagePreviewUrl) {
        URL.revokeObjectURL(this.refImagePreviewUrl)
      }
      this.refImageFile = null
      this.refImagePreviewUrl = ''
      if (this.$refs.uploadRef) this.$refs.uploadRef.clearFiles()
    },
    run() {
      this.runGenerate()
    },
    testUser() {
      const guestMob = window.sessionStorage.getItem('guest_mob') || ''
      if (this.generating) return
      if (guestMob.length === 0) {
        this.$router.push('/mob')
      }
      return guestMob
    },
    async runGenerate() {
      const guestMob = this.testUser()
      if (!guestMob.trim()) {
        return
      }
      const prompt = String(this.userPrompt0 || '')
      if (!prompt.trim()) {
        this.$message.warning('请输入创作提示词！')
        return
      }

      // =========聊天消息新增逻辑【关键修改：带上用户上传图片】========
      // 添加用户发送消息
      this.userPrompt = this.userPrompt0 + ',' + this.userPrompt
      this.chatList.push({
        role: 'user',
        content: this.userPrompt,
        refImageUrl: this.refImagePreviewUrl || null
      })
      // 添加AI加载提示消息
      this.chatList.push({
        role: 'ai',
        content: '⏳正在生成，请稍等...',
        imageUrl: null
      })
      this.scrollChatToBottom()

      this.generating = true
      try {
        const { data: resCheck } = await this.$http.post('api', {
          C_type: 'ai_upload',
          content: this.userPrompt,
          guest_mob: guestMob,
          type: 1
        })

        if (resCheck.status === 202) {
          this.$message.error('余额不足，请充值')
          // 移除加载消息
          this.chatList.pop()
          return
        }

        let res
        if (this.refImageFile) {
          const formData = new FormData()
          formData.append('refImage', this.refImageFile)
          formData.append('prompt', this.userPrompt)
          formData.append('aspect_ratio', this.selectedRatio)
          formData.append('resolution', this.selectedResolution)
          formData.append('funcType', this.currentFuncType)
          formData.append('agent', this.agentMode)
          res = await this.$http.post('/api/image-image', formData)
        } else {
          res = await this.$http.post('/api/generate-image', {
            prompt: this.userPrompt,
            aspect_ratio: this.selectedRatio,
            resolution: this.selectedResolution,
            funcType: this.currentFuncType,
            agent: this.agentMode
          })
        }

        if (res.data.code === 200) {
          const imageData = res.data.data.data[0]
          // 删除等待消息，替换为生成成功图片
          this.chatList.pop()
          this.chatList.push({
            role: 'ai',
            content: this.userPrompt,
            imageUrl: imageData.url
          })
          this.scrollChatToBottom()

          this.imgList.unshift({
            src: imageData.url,
            text: this.userPrompt,
            type: this.currentFuncType
          })
          this.saveImgListCache()
          this.$message.success('图片生成成功！')

          if (this.autoMode) {
            setTimeout(() => {
              this.runGenerate()
            }, 2000)
          }
        } else {
          // 删除加载消息
          this.chatList.pop()
          this.$message.error(res.data.msg || '生成失败')
          this.autoMode = false
        }
      } catch (e) {
        // 删除加载消息
        this.chatList.pop()
        this.$message.error('网络异常，请稍后重试')
        this.autoMode = false
        console.error(e)
      } finally {
        this.generating = false
        // 清空输入框
        this.userPrompt = ''
        this.userPrompt0 = ''
        this.clearRefImage()
      }
    },

    debounceCheckScroll: (function () {
      let timer = null
      return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.checkScroll()
        }, 100)
      }
    })(),
    checkScroll() {
      const topBox = this.$refs.topInputBox
      if (!topBox) return
      const rect = topBox.getBoundingClientRect()
      this.showBottomInput = rect.bottom <= 0
    },
    openSubMenu2() {},
    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'setting':
          this.$router.push('/user/setting')
          break
        case 'logout':
          this.exit()
          this.$message.success('退出登录')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },
    exit() {
      window.sessionStorage.setItem('token', '')
      window.sessionStorage.setItem('tokenUserType', 0)
    },
    openSubMenu() {
      this.subDrawerVisible = true
    },
    closeSubDrawer(done) {
      done()
    },
    goPage(routePath) {
      this.$router.push(routePath)
      this.subDrawerVisible = false
    },
    openImagePreview(imgItem) {
      this.currentPreviewImg = imgItem
      this.previewVisible = true
      document.body.style.overflow = 'hidden'
    },
    closePreview() {
      this.previewVisible = false
      document.body.style.overflow = ''
    },
    async downloadImage() {
      try {
        const imgUrl = this.currentPreviewImg.src
        const a = document.createElement('a')
        a.href = imgUrl
        a.download = this.currentPreviewImg.text || 'ai生成图片'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (err) {
        this.$message.info('图片存在跨域限制，请右键图片另存为')
      }
    }
  }
}
</script>

<style scoped>
/* ==========新增聊天对话样式========== */
.chat-container {
  min-height: 420px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px 10px;
  background: #fafafa;
  border-radius: 16px;
  margin-bottom: 24px;
  border: 1px solid #e8edf2;
}
.chat-empty-tip {
  text-align: center;
  color: #999;
  padding: 80px 20px;
  font-size: 15px;
}
.chat-item {
  margin-bottom: 20px;
  display: flex;
}
.chat-item.user {
  justify-content: flex-end;
}
.chat-item.ai {
  justify-content: flex-start;
}
.chat-bubble {
  max-width: 75%;
  border-radius: 12px;
  padding: 12px 16px;
}
.chat-item.user .chat-bubble {
  background: #22b8e6;
  color: #fff;
}
.chat-item.ai .chat-bubble {
  background: #f5f7fa;
  color: #333;
}
.chat-text {
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 14px;
  line-height: 1.6;
}
.chat-img-wrap {
  margin-top: 10px;
}
.chat-img-wrap img {
  max-width: 320px;
  border-radius: 8px;
  cursor: pointer;
}

.ratio-select-wrap {
  position: relative;
  width: 220px;
}

.ratio-select-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  background: #ffffff;
  font-size: small;
  height: 16px;
}

.arrow-icon {
  width: 8px;
  height: 8px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  transform: rotate(45deg);
  transition: transform 0.2s;
}

.arrow-icon.open {
  transform: rotate(-135deg);
}

.ratio-dropdown-panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  z-index: 999;
  padding: 4px;
  display: flex;
  gap: 4px;
}

.ratio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  cursor: pointer;
  white-space: nowrap;
}

.ratio-item:hover {
  background-color: #f5f7fa;
}

.ratio-item.active {
  background-color: #ecf5ff;
  color: #409eff;
}

.ratio-icon {
  width: 24px;
  height: 24px;
}

.ratio-shape {
  width: 100%;
  height: 100%;
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #fff;
}

.header-left {
  display: flex;
  align-items: center;
}

.hamburger-btn {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e8edf2;
  color: #666;
  position: relative;
  z-index: 101;
  pointer-events: auto !important;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  border: 1px solid #e8edf2;
  transition: 0.2s;
}

.header-icon:hover {
  color: #22b8e6;
  border-color: #ccebfa;
}

/* 平台选择下拉行 */
.platform-select-row {
  margin-bottom: 2px;
}

/*比例选择行*/
.ratio-select-row {
  margin-bottom: 14px;
}

.ratio-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.ratio-select-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.ratio-btn-group {
  flex: 1;
  display: flex;
  gap: 6px;
  background: #f7f7f7;
  border-radius: 12px;
  padding: 10px 8px;
  overflow-x: auto;
}

.ratio-item {
  flex-shrink: 0;
  width: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 2px;
  border-radius: 8px;
  cursor: pointer;
}

.ratio-item.active {
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.ratio-icon {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.ratio-shape {
  border: 2px solid #606266;
}

/*不同比例形状*/
.shape-auto {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}

.shape-21\:9 {
  width: 36px;
  height: 14px;
  border-radius: 3px;
}

.shape-16\:9 {
  width: 32px;
  height: 18px;
  border-radius: 3px;
}

.shape-3\:2 {
  width: 30px;
  height: 20px;
  border-radius: 3px;
}

.shape-4\:3 {
  width: 28px;
  height: 21px;
  border-radius: 3px;
}

.shape-1\:1 {
  width: 24px;
  height: 24px;
  border-radius: 3px;
}

.shape-3\:4 {
  width: 21px;
  height: 28px;
  border-radius: 3px;
}

.shape-2\:3 {
  width: 18px;
  height: 28px;
  border-radius: 3px;
}

.shape-9\:16 {
  width: 16px;
  height: 30px;
  border-radius: 3px;
}

.ratio-text {
  font-size: 12px;
  color: #444;
}

.resolution-select {
  width: 110px;
  flex-shrink: 0;
}

/* 修复：左侧导航容器，垂直排列，禁止压缩 */
.sidebar-wrap {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.sub-menu-list {
  padding-top: 12px;
}

.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
}

.sub-menu-item:hover {
  background: #f0f9fe;
  color: #22b8e6;
}

.sub-menu-item i {
  font-size: 16px;
}

.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  padding-top: 56px;
  display: flex;
}

.main-content {
  flex: 1;
  padding: 30px 20px;
  box-sizing: border-box;
}

.main-inner {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.page-top-title {
  text-align: center;
  margin-bottom: 26px;
}

.page-top-title h1 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin: 0;
}

.blue-word {
  color: #22b8e6;
}

.input-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.input-box {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
}

.input-top-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.input-left-add {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #999;
  flex-shrink: 0;
  margin-top: 4px;
}

.main-input {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  height: 70px;
  font-size: 14px;
  color: #333;
}

/* 关键：按钮左右并排 */
.input-btn-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-shrink: 0;
  margin-top: 4px;
}

.input-bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.left-btns {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.right-btns {
  display: flex;
  gap: 12px;
  align-items: center;
  color: #777;
}

.ref-img-preview {
  position: relative;
  width: 44px;
  height: 44px;
}

.ref-img-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.ref-img-close {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #333;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.func-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.tab-search-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.tab-list {
  display: flex;
  gap: 24px;
}

.tab {
  font-size: 15px;
  color: #777;
  cursor: pointer;
  padding: 4px 0;
}

.tab.active {
  color: #22b8e6;
  border-bottom: 2px solid #22b8e6;
}

.waterfall-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.waterfall-item {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  transition: transform 0.2s;
}

.waterfall-item:hover {
  transform: scale(1.02);
}

.waterfall-item img {
  width: 100%;
  display: block;
}

.item-info {
  padding: 8px;
  font-size: 13px;
  color: #333;
}

.float-ai-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #22b8e6;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  z-index: 99;
  cursor: pointer;
}

.preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-box {
  position: relative;
  max-width: 85vw;
  max-height: 85vh;
}
.preview-close {
  position: absolute;
  top: -30px;
  right: 0px;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
}
.preview-img {
  max-width: 85vw;
  max-height: 85vh;
  border-radius: 8px;
}
.preview-toolbar {
  text-align: center;
  margin-top: 12px;
}
.input-top-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

/* 按钮垂直容器：一列，按钮宽度统一 */

.input-top-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.input-btn-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  width: 130px;
}
.input-btn-col .el-button {
  width: 100% !important;
  min-width: 0 !important;
}

.main-input {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  height: 70px;
  font-size: 14px;
  color: #333;
}
.ai-write-btn {
  margin-left: 10px;
}
</style>
